<template>
  <div class="tree-canvas-wrapper">
    <canvas ref="canvas" id="treeCanvas" :width="canvasWidth" :height="canvasHeight"></canvas>
  </div>
</template>

<script>
export default {
  name: 'TreeCanvas',
  props: {
    width: {
      type: Number,
      default: 1100
    },
    height: {
      type: Number,
      default: 680
    }
  },
  data () {
    return {
      canvasWidth: this.width,
      canvasHeight: this.height
    }
  },
  mounted () {
    this.initLoveTree()
  },
  methods: {
    initLoveTree () {
      /* eslint-disable */
      // 简化依赖库检查，现在主要需要jQuery和Tree类
      let retryCount = 0
      const maxRetries = 30 // 最多重试3秒
      
      const checkGlobals = () => {
        // 检查必需的全局变量
        const hasJQuery = typeof window.$ !== 'undefined'
        const hasTree = typeof window.Tree !== 'undefined'
        
        if (hasJQuery && hasTree) {
          console.log('核心依赖库加载完成，开始初始化爱心树动画')
          this.startAnimation()
        } else {
          retryCount++
          if (retryCount < maxRetries) {
            console.log(`等待依赖库加载... (${retryCount}/${maxRetries})`, {
              jQuery: hasJQuery,
              Tree: hasTree
            })
            setTimeout(checkGlobals, 100)
          } else {
            console.error('核心依赖库加载超时，请检查网络连接和文件路径')
            // 尝试降级处理 - 直接执行动画初始化
            if (hasJQuery) {
              console.log('尝试仅使用jQuery初始化...')
              this.startAnimation()
            }
          }
        }
      }
      checkGlobals()
    },
    startAnimation() {
      /* eslint-disable */
      const canvas = window.$(this.$refs.canvas)
      if (!canvas[0].getContext) {
        return false
      }

      // 保持原始尺寸，通过CSS缩放
      const width = this.canvasWidth
      const height = this.canvasHeight
      
      // 设置canvas原始尺寸
      canvas.attr('width', width)
      canvas.attr('height', height)
      
      // 计算缩放比例
      const screenWidth = window.innerWidth
      let scale = 1
      if (screenWidth < width) {
        scale = (screenWidth - 40) / width // 留40px边距
      }
      
      // 应用CSS缩放和居中
      canvas.css({
        width: width + 'px',
        height: height + 'px',
        transform: `scale(${scale})`,
        transformOrigin: 'center top',
        display: 'block',
        margin: '0 auto'
      })
      
      const opts = {
        seed: {
          x: width / 2 - 20,
          color: 'rgb(190, 26, 37)',
          scale: 2
        },
        branch: [
          [
            535, 680, 570, 250, 500, 200, 30, 100,
            [
              [540, 500, 455, 417, 340, 400, 13, 100, [[450, 435, 434, 430, 394, 395, 2, 40]]],
              [550, 445, 600, 356, 680, 345, 12, 100, [[578, 400, 648, 409, 661, 426, 3, 80]]],
              [539, 281, 537, 248, 534, 217, 3, 40],
              [546, 397, 413, 247, 328, 244, 9, 80, [
                [427, 286, 383, 253, 371, 205, 2, 40],
                [498, 345, 435, 315, 395, 330, 4, 60]
              ]],
              [546, 357, 608, 252, 678, 221, 6, 100, [[590, 293, 646, 277, 648, 271, 2, 80]]]
            ]
          ]
        ],
        bloom: {
          num: 700,
          width: 1080,
          height: 650
        },
        footer: {
          width: 1200,
          height: 5,
          speed: 10
        }
      }

      const tree = new window.Tree(canvas[0], width, height, opts)
      const seed = tree.seed
      const foot = tree.footer

      // 使用现代Promise替代Jscex，避免生产环境兼容性问题
      const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms))
      
      const seedAnimate = async function () {
        seed.draw()
        while (seed.canScale()) {
          seed.scale(0.95)
          await sleep(10)
        }
        while (seed.canMove()) {
          seed.move(0, 2)
          foot.draw()
          await sleep(10)
        }
      }

      const growAnimate = async function () {
        do {
          tree.grow()
          await sleep(10)
        } while (tree.canGrow())
      }

      const flowAnimate = async function () {
        do {
          tree.flower(2)
          await sleep(10)
        } while (tree.canFlower())
      }

      // 树叶飘落动画
      const leafFallAnimate = async function () {
        // 保存当前完整的树作为背景
        var treeBackground = tree.ctx.getImageData(0, 0, width, height)
        var colors = ['#edda00', '#ef3f3d', '#ff85a1', '#ff9fb5', '#f363cd']
        
        // 定义树的不同部位坐标点 - 大幅扩大范围，覆盖整个爱心形状
        var treePoints = [
          // === 主干区域 ===
          {x: 535, y: 480}, {x: 540, y: 460}, {x: 545, y: 440}, {x: 550, y: 420},
          {x: 545, y: 400}, {x: 540, y: 380}, {x: 535, y: 360},
          
          // === 左侧分支区域（扩展） ===
          {x: 480, y: 360}, {x: 460, y: 340}, {x: 440, y: 320}, {x: 420, y: 300},
          {x: 400, y: 280}, {x: 380, y: 260}, {x: 360, y: 240}, {x: 340, y: 220},
          {x: 320, y: 200}, {x: 300, y: 180}, {x: 280, y: 160}, {x: 260, y: 140},
          {x: 450, y: 350}, {x: 430, y: 330}, {x: 410, y: 310}, {x: 390, y: 290},
          {x: 370, y: 270}, {x: 350, y: 250}, {x: 330, y: 230}, {x: 310, y: 210},
          
          // === 右侧分支区域（扩展） ===
          {x: 590, y: 360}, {x: 610, y: 340}, {x: 630, y: 320}, {x: 650, y: 300},
          {x: 670, y: 280}, {x: 690, y: 260}, {x: 710, y: 240}, {x: 730, y: 220},
          {x: 750, y: 200}, {x: 770, y: 180}, {x: 790, y: 160}, {x: 810, y: 140},
          {x: 620, y: 350}, {x: 640, y: 330}, {x: 660, y: 310}, {x: 680, y: 290},
          {x: 700, y: 270}, {x: 720, y: 250}, {x: 740, y: 230}, {x: 760, y: 210},
          
          // === 爱心顶部左右两个圆弧区域 ===
          // 左圆弧
          {x: 420, y: 170}, {x: 400, y: 150}, {x: 380, y: 130}, {x: 360, y: 110},
          {x: 340, y: 100}, {x: 320, y: 95}, {x: 300, y: 100}, {x: 280, y: 110},
          {x: 260, y: 130}, {x: 250, y: 150}, {x: 240, y: 170}, {x: 240, y: 190},
          // 右圆弧
          {x: 660, y: 170}, {x: 680, y: 150}, {x: 700, y: 130}, {x: 720, y: 110},
          {x: 740, y: 100}, {x: 760, y: 95}, {x: 780, y: 100}, {x: 800, y: 110},
          {x: 820, y: 130}, {x: 830, y: 150}, {x: 840, y: 170}, {x: 840, y: 190},
          
          // === 爱心中心密集区域 ===
          {x: 500, y: 240}, {x: 520, y: 220}, {x: 540, y: 200}, {x: 560, y: 220},
          {x: 480, y: 230}, {x: 460, y: 210}, {x: 440, y: 190}, {x: 420, y: 180},
          {x: 580, y: 230}, {x: 600, y: 210}, {x: 620, y: 190}, {x: 660, y: 180},
          {x: 510, y: 180}, {x: 530, y: 160}, {x: 550, y: 150}, {x: 570, y: 160},
          
          // === 爱心中层扩散区域 ===
          {x: 470, y: 280}, {x: 490, y: 270}, {x: 510, y: 260}, {x: 530, y: 250},
          {x: 550, y: 260}, {x: 570, y: 270}, {x: 590, y: 280}, {x: 610, y: 290},
          {x: 450, y: 260}, {x: 430, y: 240}, {x: 410, y: 220}, {x: 390, y: 200},
          {x: 630, y: 260}, {x: 650, y: 240}, {x: 670, y: 220}, {x: 690, y: 200},
          
          // === 爱心外围边缘区域 ===
          {x: 380, y: 320}, {x: 360, y: 300}, {x: 340, y: 280}, {x: 320, y: 260},
          {x: 300, y: 240}, {x: 280, y: 220}, {x: 270, y: 200}, {x: 260, y: 180},
          {x: 700, y: 320}, {x: 720, y: 300}, {x: 740, y: 280}, {x: 760, y: 260},
          {x: 780, y: 240}, {x: 800, y: 220}, {x: 810, y: 200}, {x: 820, y: 180},
          
          // === 爱心内部填充区域 ===
          {x: 350, y: 180}, {x: 370, y: 190}, {x: 390, y: 170}, {x: 410, y: 160},
          {x: 430, y: 150}, {x: 450, y: 140}, {x: 470, y: 135}, {x: 490, y: 130},
          {x: 510, y: 125}, {x: 530, y: 130}, {x: 550, y: 135}, {x: 570, y: 140},
          {x: 590, y: 150}, {x: 610, y: 160}, {x: 630, y: 170}, {x: 650, y: 180},
          {x: 670, y: 190}, {x: 690, y: 180}, {x: 710, y: 170}, {x: 730, y: 180},
          
          // === 爱心底部尖端区域 ===
          {x: 520, y: 300}, {x: 530, y: 320}, {x: 535, y: 340}, {x: 540, y: 360},
          {x: 545, y: 380}, {x: 550, y: 400}
        ]
        
        // 创建叶子的函数
        function createLeaf(point) {
          return {
            // 在选中点周围更大范围内随机偏移（增加自然感）
            x: point.x + Math.random() * 60 - 30, // ±30px 偏移
            y: point.y + Math.random() * 40 - 20, // ±20px 偏移
            
            // 轻柔飘落效果：慢速优雅飘落
            vx: -2.2 + Math.random() * 0.8, // -2.2 到 -1.4，轻风向左吹
            vy: 0.6 + Math.random() * 0.4,  // 0.6 到 1.0，慢速垂直飘落
            
            size: 10 + Math.random() * 12,  // 增大叶子：7-15 → 10-22
            color: colors[Math.floor(Math.random() * colors.length)],
            alpha: 0.7 + Math.random() * 0.3,
            rotation: Math.random() * Math.PI * 2,
            rotationSpeed: (Math.random() - 0.5) * 0.08, // 稍微加快旋转
            
            // 轻柔微风摆动参数
            windTime: Math.random() * 100,
            windSpeed: 0.015 + Math.random() * 0.02,  // 轻柔的风摆动
            windStrength: 0.4 + Math.random() * 0.6,  // 温和的风力摆动
            
            active: true,
            startTime: 0 // 记录叶子开始掉落的时间
          }
        }
        
        // 连续不间断的叶子飘落动画
        var activeLeaves = [] // 当前活跃的所有叶子
        var globalTime = 0
        var nextLeafTime = 0
        var leafInterval = 2000 + Math.random() * 1500 // 初始叶子生成间隔（2-3.5秒）
        
        while (true) {
          globalTime += 30 // 每帧30ms
          
          // 检查是否需要生成新叶子
          if (globalTime >= nextLeafTime) {
            // 随机生成1-3片叶子（减少数量让动画更优雅）
            var leavesToAdd = 1 + Math.floor(Math.random() * 3)
            
            for (var i = 0; i < leavesToAdd; i++) {
              var point = treePoints[Math.floor(Math.random() * treePoints.length)]
              var leaf = createLeaf(point)
              
              // 给每片叶子添加小的时间偏移，让它们不是同时出现
              leaf.startDelay = i * (100 + Math.random() * 200) // 0-300ms的随机延迟
              leaf.birthTime = globalTime + leaf.startDelay
              activeLeaves.push(leaf)
            }
            
            // 计算下一批叶子的生成时间（动态调整间隔）
            // 根据当前活跃叶子数量调整：叶子少时间隔短，叶子多时间隔长
            var baseInterval = 1800 // 基础间隔（1.8秒）
            var leafCountFactor = Math.max(0.8, Math.min(2.5, activeLeaves.length / 8)) // 根据叶子数量调整
            leafInterval = baseInterval * leafCountFactor + Math.random() * 1200 // 增加随机范围
            nextLeafTime = globalTime + leafInterval
          }
          
          // 清空画布并重绘背景
          tree.ctx.clearRect(0, 0, width, height)
          tree.ctx.putImageData(treeBackground, 0, 0)
          
          // 更新并绘制所有活跃的叶子
          for (var j = activeLeaves.length - 1; j >= 0; j--) {
            var leaf = activeLeaves[j]
            
            // 检查叶子是否应该开始显示（处理延迟启动）
            if (globalTime < leaf.birthTime) {
              continue // 还没到这片叶子的出生时间
            }
            
            if (!leaf.active) {
              activeLeaves.splice(j, 1) // 移除非活跃叶子
              continue
            }
            
            // === 微风效果模拟 ===
            leaf.windTime += leaf.windSpeed
            var windEffect = Math.sin(leaf.windTime) * leaf.windStrength
            
            // 更新位置 - 强化风力效果（明显向左下飘）
            leaf.x += leaf.vx + windEffect  // 水平：强风向左 + 摆动
            leaf.y += leaf.vy               // 垂直：重力下落
            leaf.rotation += leaf.rotationSpeed
            
            // 轻微重力加速（更加飘逸）
            leaf.vy += 0.018
            
            // 减少空气阻力，让风力效果更持久
            leaf.vx *= 0.9995
            
            // 检查是否落到底部或飘出屏幕
            if (leaf.y > height + 30 || leaf.x < -50 || leaf.x > width + 50) {
              leaf.active = false
              continue
            }
            
            // 绘制叶子
            tree.ctx.save()
            tree.ctx.globalAlpha = leaf.alpha
            tree.ctx.translate(leaf.x, leaf.y)
            tree.ctx.rotate(leaf.rotation)
            tree.ctx.scale(leaf.size / 16, leaf.size / 16)
            
            // 简化的心形绘制
            tree.ctx.beginPath()
            tree.ctx.moveTo(0, 0)
            for (var k = 0; k < 40; k++) {
              var t = k * Math.PI * 2 / 40
              var x = 16 * Math.pow(Math.sin(t), 3)
              var y = 13 * Math.cos(t) - 5 * Math.cos(2 * t) - 2 * Math.cos(3 * t) - Math.cos(4 * t)
              tree.ctx.lineTo(x, -y)
            }
            tree.ctx.closePath()
            tree.ctx.fillStyle = leaf.color
            tree.ctx.fill()
            tree.ctx.restore()
          }
          
          // 保持丝滑动画，无需额外延迟
          await sleep(30)
        }
      }

      // 树整体移动，目前没有使用
      const moveAnimate = async function () {
        tree.snapshot('p1', 0, 0, width, height)
        canvas.parent().css('background', 'url(' + tree.toDataURL('image/png') + ')')
        canvas.css('background', '#fafafa')
        await sleep(300)
        canvas.css('background', 'none')
      }

      const jumpAnimate = async function () {
        while (true) {
          tree.ctx.clearRect(0, 0, width, height)
          tree.jump()
          foot.draw()
          await sleep(25)
        }
      }

      const runAsync = async function () {
        await seedAnimate()
        await growAnimate()
        await flowAnimate()
        // await sleep(1000) // 停留1秒欣赏完整的树
        await leafFallAnimate() // 然后开始树叶飘落
      }

      runAsync()
    }
  }
}
</script>

<style scoped>
.tree-canvas-wrapper {
  width: 100%;
  max-width: 100%;
  height: 256px;
  position: relative;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}

.tree-canvas-wrapper canvas {
  display: block;
}
</style>
